import React from 'react'
import WorkExperienceItem from './WorkExperienceItem'
import styled from 'styled-components'
import {FaGraduationCap,FaPlane} from 'react-icons/fa'

export default function WorkExperience() {
    const experienceList = [
        {
            designation:"Teaching Assistant - Full Stack Web Development in Node js",
            company:"Coding Ninjas",
            duration:"February 2023 - May 2023"
        },
        {
            designation:"Software Engineer",
            company:"Paloaltosoft",
            duration:"April 2023 - Present"
        }
    ]
  return (
    <Wrapper id="experience">
            <h3 className="section-heading">
                <span><FaGraduationCap /></span>
                <span>Work Experience</span>
            </h3>
            <div className="timeline">
                {
                    experienceList.map((elem,index) => {
                        return <WorkExperienceItem key={index} data={elem} />
                    })
                }
                <div className="timeline-divider">
                    <div className="timeline-traveller"><FaPlane /></div>
                </div>
            </div>
        </Wrapper>
  )
}

const Wrapper = styled.div`
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
margin: 40px auto;
background-color: #1d1c21;


.section-heading {
    width: auto;
    padding: 20px 10px 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-heading span {
    font-size: 40px;
    color: var(--section-color);
    padding-top: 10px;
    margin-right: .5rem;
    display: flex;
    align-items: center;
}

.timeline {
    position: relative;
    width: 80%;
    margin: 5rem auto;
}

.timeline-box {
    position: relative;
    width: 40%;
    left: 5%;
    padding: .5rem 1rem;
    border-radius: 1rem;
    transition: all .3s ease-in-out;
    background-color: #151418;
    cursor: default;
    &:hover {
        box-shadow: 0px 0px 5px 2px var(--section-color);
        background-color: transparent;
    }
    &:nth-child(even) {
        left: 53%;
    }
    &:nth-child(odd):after {
        content: "";
        position: absolute;
        top: 32%;
        right: -8.7%;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        background-color: lightgrey;
        z-index: 1;
    }
    &:nth-child(even)::before {
        content: "";
        position: absolute;
        top: 32%;
        left: -8.4%;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        background-color: lightgrey;
        z-index: 1;
    }
}


    
.timeline-divider {
    position: absolute;
    height: 90%;
    width: 0;
    border: 3px dashed #0096fa6b;
    top: 8%;
    left: 50%;
}



.timeline-traveller {
    position: sticky;
    top: 30%;
    color: var(--section-color);
    transform: rotate(90deg);
    z-index: 2;
}

.timeline-traveller svg {
    font-size: 2rem;
}

.timeline-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.timeline-details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.timeline-details>h3 {
    color: var(--section-color);
}

.timeline-details>h4 {
    color: #df7843;
}

.timeline-details>p {
    color: grey;
}

.timeline-img {
    width: 50px;
    height: 50px;
}

.timeline-img>img {
    width: 100%;
    height: 100%;
    border-radius: 20px;
}

.color-white {
    color: white !important;
}
`